import React from "react";
import styled from "styled-components";
import { Sparkles } from "lucide-react";

interface XPBadgeProps {
  xp: number;
}

const XPWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  background-color: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.buttonText};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  border-radius: ${({ theme }) => theme.radii.rounded};
  box-shadow: ${({ theme }) => theme.elevations.low};
  transition: all 0.2s ease-in-out;
  animation: popUp 0.4s ease-in-out;

  @keyframes popUp {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const XPBadge: React.FC<XPBadgeProps> = ({ xp }) => {
  if (!xp || xp <= 0) return null;

  return (
    <XPWrapper>
      <Sparkles size={14} style={{ marginRight: 4 }} />
      {xp} XP
    </XPWrapper>
  );
};